import { useContext } from "react"
import { CenterContext } from "../../../Context"

export default function StoppedReasons({ stoppedReasons = [], stoppedReasonsObject }) {
    const { getStoppedReason } = useContext(CenterContext)
    /*   if(stoppedReasons.length===0) return "No reasons" */
    if (stoppedReasons.length > 0) {
        let reasons = []
        for (let reason of stoppedReasons) {
            reasons.push(getStoppedReason(reason).name);
        }
        return <>{reasons.toString()}</>;
    }
    if (stoppedReasonsObject) {
        let reasons = [];
        
        for (let reason in stoppedReasonsObject) {
           
            reasons.push(<div style={{color: getColor(reason)}}>{getStoppedReason(reason).name + ` (${stoppedReasonsObject[reason]})`}</div>);
        }
      
        return (
          <div style={{ display: "flex",gap:2, flexWrap: "wrap" }}>
                {reasons.map((r, i) => <>{r}{i<reasons.length-1 ? ", " : ""}</>)}
          </div>
        );
    }

    return <>No reasons</>
}

const redReasons = [
  "652122a0bfbdcf0644993d66",
  "652122ac00ee18c69d598a2d",
  "652146edbf7a32771fe8a59f",
];
const blueReasons = ["652122d800ee18c69d598a55", "66b25239998cea906f54aa0d"];

function getColor(reasonId) {
    if (redReasons.includes(reasonId)) return "red"
    if (blueReasons.includes(reasonId)) return "blue"
    return "black"
}